import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { Controller } from "react-hook-form";
import React from 'react';
import Error from '../Error';
import { bogusCheck, validatePostcode } from '../../utils/ValChecker';

export default function AddressInfo({ control, errors }) {
    // Render JSX using state variables and other variables

    return (
        <div className="row">
            <div className="col-xs-12 text-label-row">
                <b className="example-label">Address:</b>
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="address.line1"
                    control={control}
                    rules={{ required: true,  validate: (value) => bogusCheck(value) || '* Please enter a valid line 1' }}
                    defaultValue=""
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="First Address Line*" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="address-line1" />
                    )}

                />
                {errors.address && errors.address.line1 && <Error>{errors.address.line1.message ? errors.address.line1.message : "* Please enter your first line of address"}</Error>}               
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="address.line2"
                    control={control}
                    rules={{ required: false, validate: (value) => bogusCheck(value) || '* Please enter a valid line 2' }}
                    defaultValue=""
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="Second Address Line" floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="address-line2" />
                    )}
                />
                {errors.address && errors.address.line2 && <Error>{errors.address.line2.message}</Error>}     
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="address.line3"
                    control={control}
                    rules={{ required: false, validate: (value) => bogusCheck(value) || '* Please enter a valid line 3' }}
                    defaultValue=""
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="Third Address Line" floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="address-line3" />
                    )}
                />
                {errors.address && errors.address.line3 && <Error>{errors.address.line3.message}</Error>}  
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="address.city"
                    control={control}
                    rules={{ required: true, validate: (value) => bogusCheck(value) || '* Please enter a valid city or town' }}
                    defaultValue=""
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="City or Town*" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="address-level2" />
                    )}

                />
                {errors.address && errors.address.city && <Error>{errors.address.city.message ? errors.address.city.message : "* Please enter your address town or city"}</Error>}                            
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="address.county"
                    control={control}
                    rules={{ required: false, validate: (value) => bogusCheck(value) || '* Please enter a valid county' }}
                    defaultValue=""
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="County" floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="address-level1" />
                    )}

                />
                {errors.address && errors.address.county && <Error>{errors.address.county.message}</Error>}  
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="address.postcode"
                    control={control}
                    rules={{
                        required: true,
                        validate: (value) => (bogusCheck(value) && validatePostcode(value, 5, 10)) || '* Please enter a valid UK Postcode'
                    }}
                    defaultValue=""
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="Post Code*" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="postal-code" />
                    )}
                />
                {errors.address && errors.address.postcode && <Error>{errors.address.postcode.message ? errors.address.postcode.message : "* Please enter your UK address Postcode"}</Error>}  
            </div>
        </div>
    );
};